<template>
    <div :class="classes">


        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="iconClasses || 'h-12 w-12'" >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path d="M12 8L12 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
                <path d="M12 16V15.9888" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
                <path
                    d="M3 12C3 4.5885 4.5885 3 12 3C19.4115 3 21 4.5885 21 12C21 19.4115 19.4115 21 12 21C4.5885 21 3 19.4115 3 12Z"
                    stroke="currentColor" stroke-width="2"></path>
            </g>
        </svg>



    </div>
</template>

<script>
export default {
    name: "GaleryIcon",
    props: {
        fill: {
            type: String,
            default: "currentColor",
        },
        classes: {
            type: String,
            default: "",
        },
        iconClasses: {
            type: String,
            default: "",
        },
    },
}

</script>